var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNurse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1769,
    height: 967,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2259,
    y: 261,
    width: 1769,
    height: 967
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-2259 -261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2265.5 514.494C2265.5 502.347 2275.35 492.5 2287.49 492.5L4001.51 492.5C4013.65 492.5 4023.5 502.347 4023.5 514.494L4023.5 1199.51C4023.5 1211.65 4013.65 1221.5 4001.51 1221.5L2287.49 1221.5C2275.35 1221.5 2265.5 1211.65 2265.5 1199.51Z",
    stroke: "#BFBFBF",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 3019.05 394)"
  }, "is", /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 197.656,
    y: 0
  }, "a nurse."), /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: -650.499,
    y: 244
  }, "She"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: -502.687,
    y: 244
  }, ": 86.7%")), /*#__PURE__*/React.createElement("path", {
    d: "M2368.55 643.874 2516.55 643.874 2516.55 647.874 2368.55 647.874Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 2368.55 757)"
  }, "He", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 98.5418,
    y: 0
  }, ": 1.3%")), /*#__PURE__*/React.createElement("path", {
    d: "M2368.55 762.874 2467.55 762.874 2467.55 766.874 2368.55 766.874Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 2368.55 876)"
  }, "Kim", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 147.813,
    y: 0
  }, ": 0.1%")), /*#__PURE__*/React.createElement("path", {
    d: "M2368.55 881.874 2516.55 881.874 2516.55 885.874 2368.55 885.874Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 2368.55 995)"
  }, "Sarah", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 246.354,
    y: 0
  }, ": 0.1%")), /*#__PURE__*/React.createElement("path", {
    d: "M2368.55 1000.87 2491.55 1000.87 2614.55 1000.87 2614.55 1004.87 2491.55 1004.87 2368.55 1004.87Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 2368.55 1115)"
  }, "Maria", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 246.354,
    y: 0
  }, ": 0.09% ")), /*#__PURE__*/React.createElement("path", {
    d: "M2368.55 1120.87 2491.55 1120.87 2614.55 1120.87 2614.55 1124.87 2491.55 1124.87 2368.55 1124.87Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2534 396 2919.29 396",
    stroke: "#000000",
    strokeWidth: 10.3125,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 3269.31 638)"
  }, "Mary", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 197.084,
    y: 0
  }, ": 0.08%")), /*#__PURE__*/React.createElement("path", {
    d: "M3269.31 643.874 3367.81 643.874 3466.31 643.874 3466.31 647.874 3367.81 647.874 3269.31 647.874Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 3269.31 757)"
  }, "Anna", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 197.084,
    y: 0
  }, ": 0.08%")), /*#__PURE__*/React.createElement("path", {
    d: "M3269.31 762.874 3367.81 762.874 3466.31 762.874 3466.31 766.874 3367.81 766.874 3269.31 766.874Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 3269.31 876)"
  }, "Jane", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 197.084,
    y: 0
  }, ": 0.08%")), /*#__PURE__*/React.createElement("path", {
    d: "M3269.31 881.874 3367.81 881.874 3466.31 881.874 3466.31 885.874 3367.81 885.874 3269.31 885.874Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 3269.31 995)"
  }, "Susan", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 246.354,
    y: 0
  }, ": 0.08%")), /*#__PURE__*/React.createElement("path", {
    d: "M3269.31 1000.87 3392.31 1000.87 3515.31 1000.87 3515.31 1004.87 3392.31 1004.87 3269.31 1004.87Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 3269.31 1115)"
  }, "Karen", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 246.354,
    y: 0
  }, ": 0.08% ")), /*#__PURE__*/React.createElement("path", {
    d: "M3269.31 1120.87 3392.31 1120.87 3515.31 1120.87 3515.31 1124.87 3392.31 1124.87 3269.31 1124.87Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNurse);
export default __webpack_public_path__ + "static/media/nurse.df7c0c319d9c4182c2483f43418b9c7e.svg";
export { ForwardRef as ReactComponent };